export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'DealersCPF';
export const NAME = 'DealersCPF';
